import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { DEMO_LIBRARY } from '../../data/demo';
export const LENTIC_LOCKUP = 'https://cdn.magicpatterns.com/uploads/qmgzPPQc2zwfZy1MooT1VQ/lentic-logo-horizontal-teal-navy.svg';
export function LenticMark({
  dark = false
}: {
  dark?: boolean;
}) {
  return <Link to="/demo" className="inline-flex items-center" aria-label="Lentic" data-id="element-45" data-mp="38noj8ia3wcab">
      <img src={LENTIC_LOCKUP} alt="Lentic"
    // On the navy machine-room surface the navy wordmark needs to invert to white.
    className={`h-10 w-auto ${dark ? 'brightness-0 invert' : ''}`} data-id="element-46" data-mp="2azeis7pyxwlb" />
    </Link>;
}
export function BackLink({
  to,
  label,
  dark = false
}: {
  to: string;
  label: string;
  dark?: boolean;
}) {
  const navigate = useNavigate();
  return <button type="button" onClick={() => navigate(to)} className={`inline-flex items-center gap-1.5 font-mono-num text-[11px] uppercase tracking-[0.12em] transition-colors ${dark ? 'text-white/50 hover:text-white' : 'text-muted hover:text-ink'}`} data-id="element-47" data-mp="50myp7pi466">
      <ArrowLeftIcon className="h-3 w-3" data-id="element-48" data-mp="3hjeei8pde3li" />
      {label}
    </button>;
}
export function DemoFooter({
  dark = false
}: {
  dark?: boolean;
}) {
  return <footer className={`border-t ${dark ? 'border-white/10' : 'border-rule'}`} data-id="element-49" data-mp="38hne9jdlmoz1">
      <div className={`mx-auto flex max-w-[1400px] flex-wrap items-center gap-x-3 gap-y-1 px-8 py-4 font-mono-num text-[11px] ${dark ? 'text-white/35' : 'text-muted/70'}`} data-id="element-50" data-mp="38jrdho0jyzsz">
        <span data-id="element-51" data-mp="2yq0rcprwf1gg">Lentic demo</span>
        <span aria-hidden="true" data-id="element-52" data-mp="2ts8zfvr97fc9">·</span>
        <span data-id="element-53" data-mp="2tt0mujap66rg">FIN-001 v0.1</span>
        <span aria-hidden="true" data-id="element-54" data-mp="2pr5onno2c9hw">·</span>
        <span data-id="element-55" data-mp="2ps6y5npfknxi">library {DEMO_LIBRARY}</span>
      </div>
    </footer>;
}